import Image from "@/components/AppImage";
import { getDashboardPathUrl } from "@/config/dashboardOrigin";
import Link from "@/components/AppLink";
import testimonials_user_10 from "/public/img/testimonials-user-10.png";
import testimonials_user_8 from "/public/img/testimonials-user-8.png";
import testimonials_user_9 from "/public/img/testimonials-user-9.png";

const Comunity = () => {
  return (
    <section className="comunity-section pt-120 pb-120">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="section-header text-center">
              <h2 className="title">Over 1 000 000 users</h2>
              <p>Join and share in a community of like-minded members</p>
            </div>
          </div>
        </div>
        <div className="comunity-wrapper">
          <div className="buttons">
            <Link href={getDashboardPathUrl("/register-2")} className="cmn-btn">
              Get Started{" "}
            </Link>
          </div>
          <div className="comunity-area">
            <div className="comunity-item">
              <Image src={testimonials_user_8} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_9} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_10} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_8} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_9} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_10} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_8} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_9} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_10} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_8} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_9} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_10} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_8} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_9} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_10} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_8} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_9} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_10} alt="comunity" />
            </div>
          </div>
          <div className="comunity-area two">
            <div className="comunity-item">
              <Image src={testimonials_user_8} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_9} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_10} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_8} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_9} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_10} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_8} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_9} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_10} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_8} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_9} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_10} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_8} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_9} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_10} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_8} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_9} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_10} alt="comunity" />
            </div>
          </div>
          <div className="comunity-area three">
            <div className="comunity-item">
              <Image src={testimonials_user_8} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_9} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_10} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_8} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_9} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_10} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_8} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_9} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_10} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_8} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_9} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_10} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_8} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_9} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_10} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_8} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_9} alt="comunity" />
            </div>
            <div className="comunity-item">
              <Image src={testimonials_user_10} alt="comunity" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Comunity;
